export const BREAKPOINTS: { [key: string]: number } = {
  MOBILE: 769,
  TABLET: 1024,
  DESKTOP: 1216,
  WIDESCREEN: 1367
};
